export default __webpack_public_path__ + "static/media/Brassarts of Wild Furor.bf46043f.jpg";